#import "../fragments/product-category-fragment.graphql"

mutation ProductCategoryDelete($input: ProductCategoryDeleteInput!) {
    productCategoryDelete(input: $input) {
        productCategory {
            ...ProductCategoryFragment
        }
    }
}
